import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isDefinedString } from "et3-type-guards";

import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCoreLoginStore from "../../stores/core/core-login-store";
import {
  LOGIN_ALERT_BACKGROUND,
  LOGIN_ALERT_BORDER,
  LOGIN_ALERT_FONT_SIZE,
  LOGIN_ALERT_GAP_CSS,
  LOGIN_ALERT_HEIGHT,
  LOGIN_ALERT_HEIGHT_CSS,
  LOGIN_ALERT_PADDING_X_CSS,
  LOGIN_ALERT_RADIUS_CSS,
  LOGIN_FIELD_ICON_SIZE_CSS,
  LOGIN_FORM_COLUMN_WIDTH,
  LOGIN_FULL_WIDTH_CSS,
  LOGIN_INPUT_MIN_FONT_PX,
  LOGIN_NO_MINIMUM_CSS,
  LOGIN_TRANSITION
} from "./login-constants";
import { getFlooredFontSize } from "./login-layout";

const SignInError = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, getFontSize } = theme;
  const error = i18n.get(getCoreLoginStore().errorKey.get());
  const hasError = isDefinedString(error);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={LOGIN_FORM_COLUMN_WIDTH}
      height={LOGIN_ALERT_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={hasError ? LOGIN_ALERT_BACKGROUND : colors.all.transparent}
      style={{
        boxSizing: "border-box",
        border: LOGIN_ALERT_BORDER,
        width: LOGIN_FULL_WIDTH_CSS,
        minWidth: LOGIN_NO_MINIMUM_CSS,
        height: LOGIN_ALERT_HEIGHT_CSS,
        minHeight: LOGIN_NO_MINIMUM_CSS,
        borderRadius: LOGIN_ALERT_RADIUS_CSS,
        paddingLeft: LOGIN_ALERT_PADDING_X_CSS,
        paddingRight: LOGIN_ALERT_PADDING_X_CSS,
        gap: LOGIN_ALERT_GAP_CSS,
        opacity: hasError ? 1 : 0,
        transition: LOGIN_TRANSITION
      }}
      onClick={() => {}}
    >
      <FontAwesomeIcon
        icon={faCircleExclamation}
        color={colors.all.red}
        style={{
          width: LOGIN_FIELD_ICON_SIZE_CSS,
          height: LOGIN_FIELD_ICON_SIZE_CSS,
          flexShrink: 0
        }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={LOGIN_ALERT_FONT_SIZE}
        text={error}
        isSpan={false}
        color={colors.all.black}
        style={{
          margin: 0,
          textAlign: "left",
          fontSize: getFlooredFontSize(
            getFontSize(LOGIN_ALERT_FONT_SIZE),
            LOGIN_INPUT_MIN_FONT_PX
          )
        }}
      />
    </ET3Div>
  );
});
export default SignInError;
